import { gql } from "@apollo/client";
import CheckboxInput from "components/common/form/inputs/CheckboxInput";
import Input from "components/common/form/inputs/Input";
import Textarea from "components/common/form/inputs/Textarea";
import PageForm, { PageFormProps } from "components/common/page/PageForm";
import PersonDropdown from "components/entities/app/person/partials/inputs/PersonDropdown";
import { api } from "config/axios-context";
import { AppRoutes } from "config/router";
import { useState } from "react";
import { GetWalletFromPageQuery } from "types/graphql";
import { PersonType } from "types/person-types";
import useAppContext from "utilities/hooks/useAppContext";

const query = gql`
query GetWalletFromPage($id: Int!) {
    wallet(id: $id) {
         id,
         name,
         deposit,
         note,
         archived,
         person {
            id,
            name
         }
    }
}
`;

type FormModel = {
    id: number,
    name: string,
    deposit?: number | string,
    note?: string,
    archived: boolean,
    person?: {
        id: number,
        name: string
    }
}

const WalletFormPage = () => {
    const context = useAppContext();
    const [model, setModel] = useState<FormModel>({
        id: 0,
        name: '',
        deposit: '',
        archived: false,
        person: {
            id: 0,
            name: ''
        }
    })

    const formConfig: PageFormProps<GetWalletFromPageQuery, any, any> = {
        name: 'wallet-form-page',
        title: 'pages.person.wallet.form',
        async onSubmit(event) {
            event.preventDefault();
            if(!model.person?.id) {
                return;
            }

            try {
                const response = await api.post("/wallet/save", {
                    id: model.id,
                    name: model.name,
                    deposit: model.deposit ? Number(model.deposit) : 0,
                    note: model.note || null,
                    archived: model.archived,
                    personId: model.person.id,
                    person: null,
                    sales: null
                });

                if(response.success) {
                    context.notify('success', 'success.saving-data');
                    context.navigate(-1);
                    if(model.id === 0) {
                        setTimeout(() => {
                            context.navigate(AppRoutes.PERSON_WALLET_VIEW, { id: response.data.id });
                        }, 100);
                    }
                } else {
                    context.notify('error', 'error.saving-data', response.statusText);
                }
            } catch (error: any) {
                context.notify('error', 'error.saving-data', error.message);
            }
        },
        load: {
            query,
            resolveQueyData(data) {
                if(data?.wallet) {
                    setModel({
                        id: data.wallet.id,
                        name: data.wallet.name,
                        deposit: data.wallet.deposit,
                        note: data.wallet.note || undefined,
                        archived: data.wallet.archived,
                        person: data.wallet.person
                    })
                }
            }
        }
    }

    return (
        <PageForm {...formConfig}>
            <PersonDropdown
                value={model.person as PersonType}
                onChange={value => setModel({ ...model, person: value })}
                required
                readonly={model.id > 0}
            />
            <Input name="name" label="fields.name.name" required value={model.name} onChange={e => setModel({ ...model, name: e || '' })} />
            <Input name="deposit" label="fields.deposit.name" type="number" value={model.deposit?.toString()} onChange={e => setModel({ ...model, deposit: e || '' })} />
            <CheckboxInput name="archived" label="fields.archived.name" value={model.archived} onChange={e => setModel({ ...model, archived: e || false })} />
            <Textarea name="note" label="fields.note.name" value={model.note} onChange={e => setModel({ ...model, note: e || '' })} />
        </PageForm>
    );
};

export default WalletFormPage;
